<div class="form-section">
    <div class="form-header">
        {{ subtitle }}
    </div>
    <ng-content></ng-content>
</div>
